// This finds nested models and hoists their id onto the main object. This data format
// (with nested associations instead of ids) is the default setup for some models using
// the JSON serializer (currently implemented for v3 program service endpoints)

// i.e { id: 1, thing: { id: 2 } } becomes { id: 1, thing_id: 2, thing: { id: 2 } }
export function flattenIds<T>(model: T, ...props): T {
  props.forEach(prop => model[`${prop}_id`] = model[prop] && model[prop].id || null)
  return model
}
